import style from './style';

const Banner = ({ site }) => {
    return (
        <>
        {site === 1 && (
            <a href="https://podcasts.apple.com/ru/podcast/%D1%85%D0%BE%D0%BB%D0%B8%D0%B2%D0%B0%D1%80-%D0%BF%D0%BE%D0%B4%D0%BA%D0%B0%D1%81%D1%82-%D1%8D%D0%BF%D0%B8%D0%B7%D0%BE%D0%B4-1/id1478934863?i=1000448585028" target='_blank'>
                <div class={`${style['banner__wrapper']} ${style['banner__wrapper--' + site]}`}>
                    <div class={`${style['banner']} ${style['banner--' + site]}`}>
                        &lt;:&gt;:&lt;:&gt;:&lt;:&gt;:&lt;:&gt;:&lt;:&gt;:&lt;:&gt;:&lt;:&gt;:&lt;:&gt;:&lt;:&gt;:&lt;:&gt;:&lt;:&gt;:&lt;:&gt;:&lt;:&gt;:&lt;:&gt;:&lt;:&gt;:&lt;:&gt;<br/>
                        <br/>Слушай подкаст по первому эпизоду --> currenttime.tv/hlwr-pod<br/><br/>
                        &lt;:&gt;:&lt;:&gt;:&lt;:&gt;:&lt;:&gt;:&lt;:&gt;:&lt;:&gt;:&lt;:&gt;:&lt;:&gt;:&lt;:&gt;:&lt;:&gt;:&lt;:&gt;:&lt;:&gt;:&lt;:&gt;:&lt;:&gt;:&lt;:&gt;:&lt;:&gt;
                    </div>
                </div>
            </a>
        )}
        {site === 2 && (
            <a href="https://podcasts.apple.com/ru/podcast/%D1%85%D0%BE%D0%BB%D0%B8%D0%B2%D0%B0%D1%80-%D0%BF%D0%BE%D0%B4%D0%BA%D0%B0%D1%81%D1%82-%D1%8D%D0%BF%D0%B8%D0%B7%D0%BE%D0%B4-2/id1478934863?i=1000449499928" target='_blank'>
                <div class={`${style['banner__wrapper']} ${style['banner__wrapper--' + site]}`}>
                    <div class={`${style['banner']} ${style['banner--' + site]}`}>
                        <img src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/bobbin.png'/>
                        Слушай подкаст по второму эпизоду тут
                        <img src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/bobbin.png'/>
                    </div>
                </div>
            </a>
        )}
        {site === 3 && (
            <a href="https://podcasts.apple.com/ru/podcast/%D1%85%D0%BE%D0%BB%D0%B8%D0%B2%D0%B0%D1%80-%D0%BF%D0%BE%D0%B4%D0%BA%D0%B0%D1%81%D1%82-%D1%8D%D0%BF%D0%B8%D0%B7%D0%BE%D0%B4-3/id1478934863?i=1000450335027" target='_blank'>
                <div class={`${style['banner__wrapper']} ${style['banner__wrapper--' + site]}`}>
                    <div class={`${style['banner']} ${style['banner--' + site]}`}>
                        Быть может, вы искали: <span>Холивар подкаст эпизод 3</span>?
                    </div>
                </div>
            </a>
        )}
        {site === 4 && (
            <a href="https://www.currenttime.tv/a/holywar-podcast-loshak/30184763.html" target='_blank'>
                <div class={`${style['banner__wrapper']} ${style['banner__wrapper--' + site]}`}>
                    <div class={`${style['banner']} ${style['banner--' + site]}`}>
                        <span>Реклама:</span><br/><br/>
                        Послушайте подкаст по четвертому эпизоду!<br/>
                        <span>https://www.currenttime.tv/a/holywar-podcast-loshak/30184763.html</span>
                    </div>
                </div>
            </a>
        )}

        {site === 5 && (
            <a href="https://www.currenttime.tv/a/holywar-podcast-loshak/30196874.html" target='_blank'>
                <div class={`${style['banner__wrapper']} ${style['banner__wrapper--' + site]}`}>
                    <div class={`${style['banner']} ${style['banner--' + site]}`}>
                        <div class={`${style['banner__title']} ${style['banner__title--' + site]}`}>
                            <span>ХОЛИВАР. ИСТОРИЯ РУНЕТА</span> октябрь 3, 2019 17:40
                        </div>
                        <h3>Подкаст Холивара</h3>
                        Слушайте серию подкаста по пятому эпизоду на сайте Настоящего времени
                        <span style='text-decoration: underline'> здесь</span>.
                    </div>
                </div>
            </a>
        )}

        {site === 6 && (
            <a href="https://www.currenttime.tv/a/podcas-holywar-loshak/30210021.html" target='_blank'>
                <div class={`${style['banner__wrapper']} ${style['banner__wrapper--' + site]}`}>
                    <div class={`${style['banner']} ${style['banner--' + site]}`}>
                    Слушай подкаст по шестому эпизоду <span>здесь</span>.
                    </div>
                </div>
            </a>
        )}

        {site === 7 && (
            <a href="https://www.currenttime.tv/a/podcast-holywar-loshak/30221243.html" target='_blank'>
                <div class={`${style['banner__wrapper']} ${style['banner__wrapper--' + site]}`}>
                    <div class={`${style['banner']} ${style['banner--' + site]}`}>
                    Слушай подкаст по седьмому эпизоду <span>тут</span>.
                    </div>
                </div>
            </a>
        )}

        </>
    )
}

export default Banner;
